module.exports = (__webpack_require__(9))(24);


//////////////////
// WEBPACK FOOTER
// delegated ./assets/js/lib/registry.js from dll-reference carbon.core
// module id = 24
// module chunks = 0